import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './index.css';

const AdminLogin = () => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const response = await axios.post(process.env.REACT_APP_BASE_URL + '/api/login', {
                phone: phone,
                password: password
            });

            if (response.data.status === 200) {
                const item = {
                    time: new Date().getTime(),
                    user: response.data.user
                };
                localStorage.setItem('hongyuanuser', JSON.stringify(item));
                navigate('/admin');
            } else {
                setError('Invalid phone or password');
            }
        } catch (error) {
            console.error(error);
            setError('Login failed. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-login-wrapper">
            <div className="admin-login-container">
                <div className="admin-login-card">
                    <div className="admin-login-header">
                        <h1 className="admin-login-title">Admin Login</h1>
                        <p className="admin-login-subtitle">Sign in to access the admin dashboard</p>
                    </div>

                    <form className="admin-login-form" onSubmit={handleSubmit}>
                        {error && (
                            <div className="admin-alert admin-alert-error">
                                {error}
                            </div>
                        )}

                        <div className="admin-form-group">
                            <label htmlFor="phone" className="admin-form-label">Phone Number</label>
                            <input
                                type="tel"
                                id="phone"
                                className="admin-form-input"
                                placeholder="Enter your phone number"
                                value={phone}
                                onChange={(e) => setPhone(e.target.value)}
                                required
                            />
                        </div>

                        <div className="admin-form-group">
                            <label htmlFor="password" className="admin-form-label">Password</label>
                            <input
                                type="password"
                                id="password"
                                className="admin-form-input"
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                        </div>

                        <button 
                            type="submit" 
                            className="admin-btn-submit"
                            disabled={loading}
                        >
                            {loading ? 'Signing in...' : 'Sign In'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AdminLogin;
